"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDPTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Typography_1 = require("../../../../atomic/atoms/Typography");
const PDPTitle = ({ title, extendedClasses }) => {
    return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, { variant: "h1", tagName: "h1", className: extendedClasses, children: title }));
};
exports.PDPTitle = PDPTitle;
